import { ReactNode, useMemo } from 'react';

export interface UnderlineTabProps {
  active: boolean;
  onClick: () => void;
  size: 'small' | 'large';
  direction: 'horizontal' | 'vertical';
  children: ReactNode;
}

const UnderlineTab = ({
  active,
  onClick,
  size,
  direction,
  children,
}: UnderlineTabProps) => {
  const styles = useMemo(() => {
    return {
      button: [
        'transition-colors h-full',
        size === 'small'
          ? 'py-4 px-6 text-sm font-medium'
          : 'text-sm md:text-lg',
        size === 'large'
          ? direction === 'horizontal'
            ? 'px-1 md:px-6 py-2'
            : 'py-4 px-6'
          : '',
        direction === 'horizontal' ? 'border-b-2' : 'border-l-2',
        active ? 'border-pink-500' : 'border-transparent',
        !active && size === 'large'
          ? 'hover:bg-gray-100 hover:rounded-lg hover:border-transparent'
          : '',
      ].join(' '),
      li: [
        'text-gray-400 dark:text-gray-500 transition-colors',
        active
          ? 'border-pink-500 text-gray-800 dark:text-gray-800'
          : 'hover:text-gray-500 dark:hover:text-gray-800/50',
        direction === 'horizontal' ? 'border-b' : 'border-l',
        size === 'small' ? 'font-normal' : 'font-bold',
        !active && size === 'large'
          ? 'border-b-0 border-gray-300 hover:border-transparent'
          : '',
      ].join(' '),
    };
  }, [size, direction, active]);

  return (
    <li className={styles.li}>
      <button type="button" onClick={onClick} className={`${styles.button}`}>
        {children}
      </button>
    </li>
  );
};

export default UnderlineTab;
